export const FIELDS = {
  CREATED_AT: 'createdAt',
  FIELDS: 'fields'
};

export const A4_SIZE = { HEIGHT: 295, WIDTH: 210 };
